import Swiper, { Autoplay, Navigation, Grid, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

/* =========================
   HELPERS
========================= */

// debounce
function debounce(fn, delay = 150) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

// NEW: calc wrapper max-height + slides min-height
function applyWrapperAndSlidesHeight(wrapper, slides) {
  if (!wrapper || slides.length < 3) return;

  const heights = [...slides].map(slide => slide.offsetHeight);

  // сортируем по убыванию
  heights.sort((a, b) => b - a);

  const tallestSlideHeight = heights[0];          // NEW
  const wrapperMaxHeight = heights[0] + heights[1] + 100;

  // wrapper max-height
  wrapper.style.maxHeight = `${wrapperMaxHeight}px`;

  // NEW: set min-height for all slides
  slides.forEach(slide => {
    slide.style.minHeight = `${tallestSlideHeight}px`;
  });
}

let feedbackSwiperWr = document.querySelectorAll('.feedback-swiper-wr');

feedbackSwiperWr.forEach((el) => {
  if (!el) return;

  let swiperEl = el.querySelector('.swiper');
  let nextEl = el.querySelector('.swiper-button-next');
  let prevEl = el.querySelector('.swiper-button-prev');
  let slides = el.querySelectorAll('.swiper-slide');
  let slidesCount = slides.length;
  let paginationEl = el.querySelector('.swiper-pagination');

  let wrapper = swiperEl.querySelector('.swiper-wrapper');

  // NEW: debounced resize handler
  const debouncedResizeCalc = debounce(() => {
    applyWrapperAndSlidesHeight(wrapper, slides);
  }, 150);

  let swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation, Grid, Pagination],
    observer: true,
    observeParents: true,
    spaceBetween: 16,
    slidesPerView: 1,
    threshold: 10,

    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },

    pagination: {
      el: paginationEl,
      clickable: true,
    },

    breakpoints: {
      641: {
        slidesPerView: 2,
        // spaceBetween: 28,
        spaceBetween: 16,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
      768: {
        slidesPerView: 2,
        // spaceBetween: 30,
        spaceBetween: 20,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
      850: {
        slidesPerView: 2,
        // spaceBetween: 40,
        spaceBetween: 24,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
      1250: {
        slidesPerView: 2,
        // spaceBetween: 53,
        spaceBetween: 32,
        grid: {
          rows: 2,
          fill: 'row',
        },
      },
    },

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: window.innerWidth >= 640,
    },

    on: {
      afterInit() {
        // existing logic
        wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');

        // NEW: initial calc
        if (slidesCount >= 3) {
          applyWrapperAndSlidesHeight(wrapper, slides);

          // NEW: second recalculation after init
          setTimeout(() => {
            applyWrapperAndSlidesHeight(wrapper, slides);
          }, 100);
        }
      },

      resize() {
        // existing logic
        wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');

        // NEW: debounced resize calc
        if (slidesCount >= 3) {
          debouncedResizeCalc();
        }
      },
    },
  });

  swiperObserver(swiper);
});
